<template>
    <div>
        <div v-if="rules">
            <template v-for="(rule, i) in rules" :key="i">
                <rule :rule="rule" :destination-id="destinationId" :rule-id="i" class="mt-2"></rule>
            </template>
        </div>

        <div class="mt-4">
            <button @click="addNewCondition" type="button"
                    class="inline-flex items-center px-2.5 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                + добавить условие
            </button>
        </div>
    </div>
</template>

<script>
import ModalCondition from "./ModalCondition.vue";
import Rule from "./Rule.vue";

export default {
    components: {
        ModalCondition,
        Rule
    },

    props: {
        rules: {
            default: []
        },
        destinationId: {
            required: true
        }
    },

    methods: {
        addNewCondition() {
            this.emitter.emit("toggle-qr-condition-modal", {
                destinationId: this.destinationId,
                ruleId: null,
                rule: null
            });
        },
    }
}
</script>
